import React from "react";

function CopyIcon() {
  return (
    <svg width="36" height="24" viewBox="0 -4 36 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.303 12.105c1.575 0 2.376-.954 2.727-1.755l-1.566-.72c-.153.468-.621.873-1.161.873-.873 0-1.458-.666-1.458-1.503 0-.837.585-1.503 1.458-1.503.54 0 1.008.405 1.161.873l1.566-.729c-.36-.828-1.152-1.746-2.727-1.746C5.422 5.895 4 7.146 4 9c0 1.845 1.422 3.105 3.303 3.105ZM14.28 12.105c1.854 0 3.285-1.26 3.285-3.105s-1.43-3.105-3.285-3.105c-1.854 0-3.285 1.26-3.285 3.105s1.431 3.105 3.285 3.105Zm0-1.602c-.873 0-1.44-.666-1.44-1.503 0-.837.567-1.503 1.44-1.503s1.44.666 1.44 1.503c0 .837-.567 1.503-1.44 1.503ZM20.748 11.997v-1.89h1.386c1.404 0 2.16-.936 2.16-2.052 0-1.125-.756-2.061-2.16-2.061H18.93v6.003h1.818ZM21.9 8.523h-1.152v-.945H21.9c.306 0 .549.153.549.477 0 .315-.243.468-.549.468ZM28.941 11.997V9.612l2.232-3.618H29.13l-1.098 2.025-1.116-2.025h-2.043l2.25 3.618v2.385h1.818Z"
        fill="#212121"
      />
      <rect x="1" y="1" width="33.173" height="16" rx="3" stroke="#212121" strokeWidth="2" />
    </svg>
  );
}

export default CopyIcon;
